export const getBooleanFromString = (booleanString: string | null | void): boolean => {
    return booleanString === 'true' || false;
};
